import { type Country } from 'react-phone-number-input';
import ru from 'react-phone-number-input/locale/ru';

import {
  PhoneInput as PhoneInputBase,
  type PhoneInputProps,
} from '../../ui/phone-input';

export const DEFAULT_COUNTRY: Country = 'RU';

export const PhoneInput = (props: PhoneInputProps) => {
  return (
    <PhoneInputBase defaultCountry="RU" labels={ru} international {...props} />
  );
};
